import { createContext, useContext, useState, useCallback } from 'react';

const translations = {
  en: {
    // Navigation
    nav: {
      home: 'Home',
      dashboard: 'Dashboard',
      login: 'Login',
      register: 'Register',
      logout: 'Logout',
      admin: 'Admin Panel'
    },
    // Hero
    hero: {
      title: 'Book Amazing Experiences',
      subtitle: 'Request what you want, certified local providers send offers in real time, you choose your favorite within 12 hours.',
      cta: 'Receive proposals'
    },
    // Categories
    categories: {
      title: 'What are you looking for?',
      yacht: 'Yachts',
      tour: 'Tours',
      activity: 'Activities',
      party: 'Parties',
      car_rental: 'Car Rental',
      lodging: 'Lodging'
    },
    // Locations
    locations: {
      title: 'Where to?',
      playa_del_carmen: 'Playa del Carmen',
      cancun: 'Cancún',
      tulum: 'Tulum',
      quintana_roo: 'Quintana Roo',
      los_cabos: 'Los Cabos'
    },
    // Auth
    auth: {
      loginTitle: 'Welcome Back',
      registerTitle: 'Join BidTrip',
      email: 'Email',
      password: 'Password',
      name: 'Full Name',
      phone: 'Phone (optional)',
      loginBtn: 'Login',
      registerBtn: 'Create Account',
      noAccount: "Don't have an account?",
      hasAccount: 'Already have an account?',
      tourist: 'Tourist',
      provider: 'Provider',
      selectRole: 'I am a...',
      companyName: 'Company Name',
      description: 'Description',
      selectCategories: 'Select Categories',
      selectLocations: 'Select Locations'
    },
    // Request
    request: {
      createTitle: 'Create Your Request',
      category: 'Category',
      location: 'Location',
      date: 'Date',
      time: 'Time',
      people: 'Number of People',
      notes: 'Additional Notes (optional)',
      budget: 'Budget',
      suggestedBudget: 'Suggested Budget',
      customBudget: 'Set Custom Budget',
      minPrice: 'Min Price',
      maxPrice: 'Max Price',
      avgPrice: 'Average Price',
      submit: 'Submit Request',
      myRequests: 'My Requests',
      viewOffers: 'View Offers',
      status: {
        active: 'Active',
        booked: 'Booked',
        expired: 'Expired',
        cancelled: 'Cancelled'
      }
    },
    // Offers
    offers: {
      title: 'Offers',
      noOffers: 'No offers yet. Providers are reviewing your request.',
      countdown: 'Time Remaining',
      selectOffer: 'Select This Offer',
      price: 'Price',
      includes: 'Includes',
      provider: 'Provider',
      verified: 'Verified',
      rating: 'Rating'
    },
    // Provider
    provider: {
      dashboard: 'Provider Dashboard',
      incomingRequests: 'Incoming Requests',
      myOffers: 'My Offers',
      sendOffer: 'Send Offer',
      noRequests: 'No matching requests at the moment.',
      offerPrice: 'Your Price (USD)',
      offerDescription: 'Description',
      offerIncludes: 'What\'s Included (one per line)',
      submitOffer: 'Submit Offer'
    },
    // Booking
    booking: {
      title: 'Booking Confirmation',
      totalPrice: 'Total Price',
      platformFee: 'Platform Fee (15%)',
      providerAmount: 'Provider Receives',
      paymentType: 'Payment Type',
      payFull: 'Pay Full Amount',
      payPartial: 'Pay 50% Now',
      confirmAndPay: 'Confirm & Pay',
      myBookings: 'My Bookings',
      status: {
        pending_payment: 'Pending Payment',
        confirmed: 'Confirmed',
        completed: 'Completed',
        cancelled: 'Cancelled'
      },
      whatsapp: 'Contact via WhatsApp'
    },
    // Chuy
    chuy: {
      greeting: "Hey! I'm Chuy, your personal concierge. How can I help you today?",
      placeholder: 'Ask me anything about your trip...',
      send: 'Send',
      cta: "Don't know where to go? Ask me",
      help: 'Chuy Help',
      emergency: 'Emergency numbers',
      tips: 'Travel tips',
      slang: 'Mexican slang'
    },
    // Common
    common: {
      loading: 'Loading...',
      error: 'An error occurred',
      success: 'Success!',
      cancel: 'Cancel',
      confirm: 'Confirm',
      back: 'Back',
      next: 'Next',
      usd: 'USD',
      reviews: 'reviews'
    }
  },
  es: {
    // Navigation
    nav: {
      home: 'Inicio',
      dashboard: 'Panel',
      login: 'Iniciar Sesión',
      register: 'Registrarse',
      logout: 'Cerrar Sesión',
      admin: 'Panel Admin'
    },
    // Hero
    hero: {
      title: 'Reserva Experiencias Increíbles',
      subtitle: 'Solicita lo que quieras, proveedores locales certificados te mandan ofertas en tiempo real, eliges tu favorita en menos de 12 horas.',
      cta: 'Recibir propuestas'
    },
    // Categories
    categories: {
      title: '¿Qué estás buscando?',
      yacht: 'Yates',
      tour: 'Tours',
      activity: 'Actividades',
      party: 'Fiestas',
      car_rental: 'Renta de Autos',
      lodging: 'Hospedaje'
    },
    // Locations
    locations: {
      title: '¿A dónde?',
      playa_del_carmen: 'Playa del Carmen',
      cancun: 'Cancún',
      tulum: 'Tulum',
      quintana_roo: 'Quintana Roo',
      los_cabos: 'Los Cabos'
    },
    // Auth
    auth: {
      loginTitle: 'Bienvenido de Nuevo',
      registerTitle: 'Únete a BidTrip',
      email: 'Correo Electrónico',
      password: 'Contraseña',
      name: 'Nombre Completo',
      phone: 'Teléfono (opcional)',
      loginBtn: 'Iniciar Sesión',
      registerBtn: 'Crear Cuenta',
      noAccount: '¿No tienes cuenta?',
      hasAccount: '¿Ya tienes cuenta?',
      tourist: 'Turista',
      provider: 'Proveedor',
      selectRole: 'Soy...',
      companyName: 'Nombre de Empresa',
      description: 'Descripción',
      selectCategories: 'Selecciona Categorías',
      selectLocations: 'Selecciona Ubicaciones'
    },
    // Request
    request: {
      createTitle: 'Crea Tu Solicitud',
      category: 'Categoría',
      location: 'Ubicación',
      date: 'Fecha',
      time: 'Hora',
      people: 'Número de Personas',
      notes: 'Notas Adicionales (opcional)',
      budget: 'Presupuesto',
      suggestedBudget: 'Presupuesto Sugerido',
      customBudget: 'Establecer Presupuesto',
      minPrice: 'Precio Mín',
      maxPrice: 'Precio Máx',
      avgPrice: 'Precio Promedio',
      submit: 'Enviar Solicitud',
      myRequests: 'Mis Solicitudes',
      viewOffers: 'Ver Ofertas',
      status: {
        active: 'Activo',
        booked: 'Reservado',
        expired: 'Expirado',
        cancelled: 'Cancelado'
      }
    },
    // Offers
    offers: {
      title: 'Ofertas',
      noOffers: 'Sin ofertas aún. Los proveedores están revisando tu solicitud.',
      countdown: 'Tiempo Restante',
      selectOffer: 'Seleccionar Esta Oferta',
      price: 'Precio',
      includes: 'Incluye',
      provider: 'Proveedor',
      verified: 'Verificado',
      rating: 'Calificación'
    },
    // Provider
    provider: {
      dashboard: 'Panel de Proveedor',
      incomingRequests: 'Solicitudes Entrantes',
      myOffers: 'Mis Ofertas',
      sendOffer: 'Enviar Oferta',
      noRequests: 'No hay solicitudes coincidentes por el momento.',
      offerPrice: 'Tu Precio (USD)',
      offerDescription: 'Descripción',
      offerIncludes: 'Qué Incluye (uno por línea)',
      submitOffer: 'Enviar Oferta'
    },
    // Booking
    booking: {
      title: 'Confirmación de Reserva',
      totalPrice: 'Precio Total',
      platformFee: 'Comisión (15%)',
      providerAmount: 'Proveedor Recibe',
      paymentType: 'Tipo de Pago',
      payFull: 'Pagar Total',
      payPartial: 'Pagar 50% Ahora',
      confirmAndPay: 'Confirmar y Pagar',
      myBookings: 'Mis Reservas',
      status: {
        pending_payment: 'Pendiente de Pago',
        confirmed: 'Confirmado',
        completed: 'Completado',
        cancelled: 'Cancelado'
      },
      whatsapp: 'Contactar por WhatsApp'
    },
    // Chuy
    chuy: {
      greeting: '¡Hola! Soy Chuy, tu concierge personal. ¿Cómo puedo ayudarte hoy?',
      placeholder: 'Pregúntame lo que sea sobre tu viaje...',
      send: 'Enviar',
      cta: '¿No sabes a dónde ir? Pregúntame',
      help: 'Chuy Ayuda',
      emergency: 'Números de emergencia',
      tips: 'Tips de viaje',
      slang: 'Slang mexicano'
    },
    // Common
    common: {
      loading: 'Cargando...',
      error: 'Ocurrió un error',
      success: '¡Éxito!',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      back: 'Volver',
      next: 'Siguiente',
      usd: 'USD',
      reviews: 'reseñas'
    }
  }
};

const LanguageContext = createContext(null);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    if (saved) return saved;
    const browserLang = navigator.language.split('-')[0];
    return browserLang === 'es' ? 'es' : 'en';
  });

  const t = useCallback((key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  }, [language]);

  const toggleLanguage = () => {
    const newLang = language === 'en' ? 'es' : 'en';
    setLanguage(newLang);
    localStorage.setItem('language', newLang);
  };

  return (
    <LanguageContext.Provider value={{ language, t, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
